<div class="d-flex flex-column content-container">
  <div class="d-flex flex-row mt-5 header-padding">
    <div class="sub-heading mb-3">
      <adp-label [labelKey]="offer + '_Title'"></adp-label>
    </div>
  </div>
  <div class="description">
    <p class="content">
      <adp-label [labelKey]="offer + '_Subtitle'"></adp-label>
    </p>
    <div class="list-table-padding">
      <app-offer-table [offer]="offer" [contractId]="contractId" [userEmail]="userEmail" [userType]="userType"
        [usersOnContract]="usersOnContract"></app-offer-table>
    </div>
  </div>
</div>